import { useEffect, useState } from "react";
import { Button, Modal, Form, message, Row, Col, Select } from "antd";
import Moment from "react-moment";
import fetchAllUsers from "../../../../services/fetchAllUsers";
import confirmRequest from "../../../../services/confirmRequest";

const { Option } = Select;

export default function DriveBooking({
  isVisible,
  selected,
  setConfirmModal,
  handleFetchDrives,
}: any) {
  const [form] = Form.useForm();
  const [users, setUsers] = useState<any>([]);

  const onSubmit = async () => {
    let { assignedTo } = form.getFieldsValue();
    const data = {
      status: "Confirmed",
      name: selected?.customer_name,
      mobile: selected?.customer_mobile,
      is_confirmed: true,
      assignedTo,
    };
    const drive_id = selected._id;
    const response = await confirmRequest(data, drive_id);
    if (response.success) {
      message.success("Confirmed successfully");
    } else {
      message.error("Something went wrong");
    }
    setConfirmModal(false);
    await handleFetchDrives();
  };

  const hideModal = () => {
    setConfirmModal(false);
  };

  const handleFetchUsers = async () => {
    const response = await fetchAllUsers();
    // const filtered = response?.payload.filter((item: any) => !item.isConsultant);
    setUsers(response?.payload);
  };

  const userOptions = users?.map((user: any, index: number) => (
    <Option value={user?._id} key={index}>
      {user?.firstname} {user?.lastname}
    </Option>
  ));

  useEffect(() => {
    form.resetFields();
    handleFetchUsers();
  }, [selected]);

  return (
    <Modal
      visible={isVisible}
      title="Confirm Request"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="UpdateBooking"
          htmlType="submit"
          type="primary"
          danger
          onSubmit={onSubmit}
        >
          Confirm
        </Button>,
      ]}
    >
      <Form
        id="UpdateBooking"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
      >
        <div className="pb-4">
          <div className="flex text-black font-bold text-lg">
            VEHICLE: {selected?.title}
          </div>
          <div className="flex ">
            <span className="w-12">Date: </span>
            <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
          </div>
          <div className="flex ">
            <span className="w-12">Time : </span>
            <Moment format="HH:mm A">{selected?.drivetime?.starttime}</Moment>
            <div className="mx-2">-</div>
            <Moment format="HH:mm A">{selected?.drivetime?.endtime}</Moment>
          </div>
        </div>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="assignedTo"
              label="Assign To"
              rules={[
                {
                  required: true,
                  message: "Please select assignee",
                },
              ]}
            >
              <Select placeholder="Assign To">{userOptions}</Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
